import { createAction, props } from '@ngrx/store';

export const setQuotesAction = createAction(
  '[QUOTES] Set QUOTES',
  props<{ quote: number }>()
);